import React from "react";
import { Box, Link, Typography } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"; // Add arrow icon
import SearchBar from "./SearchBar";
import "./home.css";
import { Link as RouterLink } from "react-router-dom";
import { fonts, headingFonts, semiBoldFonts } from "../../Styles/Styles";

const popularLinks = [
  { label: "Vehicles", to: "/category/Vehicles" },
  { label: "Electronics", to: "/category/Electronics" },
  { label: "Real Estate", to: "/category/Real-Estate" },
];

const HeroSection = () => {
  return (
    <Box
      sx={{
        backgroundImage: "url('/Images/Home_1.jpg')", // Hero background image
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "auto",
        minHeight: "500px", // Ensures a minimum height for small device
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
        position: "relative",
        padding: { xs: "80px 20px", sm: "100px 30px", md: "150px 30px" },
        animation: "fadeIn .5s ease-in", // Fade-in effect for hero section
      }}
    >
      {/* Overlay for better text visibility */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Slightly darker for classy feel
          animation: "fadeIn .5s ease-in", // Fade-in animation for overlay
        }}
      />
      {/* Hero content */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center", // Center text inside the container
        }}
      >
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            maxWidth: "800px",
            margin: "0 auto",
            animation: "slideIn .5s ease-out", // Slide-in effect for heading and subheading
          }}
        >
          {/* Heading */}
          <Typography
            variant="h3"
            sx={{
              ...headingFonts,
              letterSpacing: 2,
              fontSize: { xs: "2.5rem", sm: "3.5rem" },
              lineHeight: "1.2",
              marginBottom: 2,
              textTransform: "uppercase",
              color: "#fff",
              textShadow: "0px 4px 6px rgba(0, 0, 0, 0.3)", // Elegant text shadow
              animation: "fadeIn .5s ease-in", // Fade-in effect for heading
            }}
          >
            Find Your{" "}
            <span
              style={{
                ...semiBoldFonts,
                letterSpacing: 2,
                color: "var(--primary-color)",
              }}
            >
              Perfect Deal
            </span>
          </Typography>

          {/* Subheading */}
          <Typography
            variant="h6"
            sx={{
              ...fonts,
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "1.25rem",
              marginBottom: 2,
              lineHeight: "1.6",
              textAlign: "center", // Ensure subheading is centered
              animation: "fadeIn 1s ease-in", // Fade-in effect for subheading
            }}
          >
            Discover a curated selection of classified ads, with everything you
            need – from gadgets to real estate and beyond.
          </Typography>

          {/* Arrow Icon pointing to Search Bar */}
          <Box>
            <ArrowDownwardIcon
              sx={{
                fontSize: "3rem",
                stroke: "var(--primary-color)", // Border color
                strokeWidth: "0.2px", // Border thickness
                color: "white",
                animation: "bounce 1.5s infinite", // Subtle bounce animation
              }}
            />
          </Box>
        </Box>
        {/* Search Bar */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
            zIndex: 1,
            margin: "0 auto", // Center the SearchBar
            animation: "slideUp .5s ease-out", // Slide-up effect for the search bar
          }}
        >
          <SearchBar />
        </Box>
        <Typography
          variant="body1"
          sx={{
            ...fonts,
            color: "white",
            marginTop: 1,
            lineHeight: "1.6",
            position: "relative",
            zIndex: 1,
            textAlign: "center", // Ensure subheading is centered
            animation: "fadeIn 1s ease-in", // Fade-in effect for subheading
          }}
        >
          What's Popular:{" "}
          {popularLinks
            .map((link, index) => (
              <Link
                key={index}
                component={RouterLink}
                to={link.to}
                sx={{
                  color: "white",
                  textDecoration: "none",
                  position: "relative",
                  "&:after": {
                    content: '""',
                    position: "absolute",
                    width: "100%",
                    height: "2px",
                    bottom: 0,
                    left: 0,
                    backgroundColor: "var(--primary-color)",
                    transform: "scaleX(0)",
                    transformOrigin: "right",
                    transition: "transform 0.3s ease-in-out",
                  },
                  "&:hover": { color: "white" },
                  "&:hover:after": {
                    transform: "scaleX(1)",
                    transformOrigin: "left",
                  },
                }}
              >
                {link.label}
              </Link>
            ))
            .reduce((prev, curr) => [prev, ", ", curr])}
        </Typography>
      </Box>
    </Box>
  );
};

export default HeroSection;
